import React from 'react';

import {BasicInformationPanelState} from 'FileStates';
import SubtemplateActions from 'notebook/entry-templates/SubtemplateActions';
import notifications from 'notifications';
import ReactPanelBaseView, {Subpanel} from 'toolbar/ReactPanelBaseView';

import {BaseTemplateInformationSubpanel} from './TemplateInformationPanelView';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
class SubtemplateInformationPanelView extends ReactPanelBaseView<BasicInformationPanelState, any> {
  saveModel = (name: string, templateCollectionId: string): void => {
    SubtemplateActions.saveFileData(this.model.id, {
      data: {name, templateCollection: templateCollectionId},
      success: this.onSaveSuccess,
    });
  };

  onSaveSuccess = (): void => {
    notifications.success('Sub-Template successfully updated.');
  };

  deleteModel = (): void => {
    SubtemplateActions.delete(this.model.id, this.model.templateCollection().id);
  };

  getSubpanels = (): Array<Subpanel> => [
    {
      key: 'information',
      title: 'Information',
      component: (
        <BaseTemplateInformationSubpanel
          templateId={this.model.id}
          initialName={this.model.name()}
          initialCollection={this.model.templateCollection()}
          archiveRecord={this.model.archiveRecord()}
          permissions={this.model.permissions()}
          saveModel={this.saveModel}
          deleteModel={this.deleteModel}
        />
      ),
    },
  ];
}

export default SubtemplateInformationPanelView;
